<template>
  <div class="main">
    <div class="header">
      <i-button type="primary" class="loginButton" @click="GoCreate">新建试卷</i-button>
      <div class="filter">
        <Select
          v-model="teacherId"
          clearable
          placeholder="按老师筛选"
          style="width:160px;margin-right:10px;"
          @on-change="OnFilterChange"
        >
          <Option :value="0">全部老师</Option>
          <Option
            v-for="t in teacherList"
            :key="t.uid || t.id"
            :value="t.uid || t.id"
          >{{ t.name || t.nickname }}</Option>
        </Select>
        <Input
          v-model="keyword"
          clearable
          search
          enter-button="搜索"
          placeholder="输入试卷名称"
          style="width:300px;"
          @on-search="OnSearch"
        />
      </div>
    </div>
    <div class="content">
      <i-table border :columns="columns" :data="list"/>
    </div>
    <div class="footer">
      <Page
        :total="count"
        :page-size="pageSize"
        :current="currentPage"
        :page-size-opts="[10,20,50]"
        show-total
        show-elevator
        show-sizer
        @on-change="ChangePage"
        @on-page-size-change="ChangePageSize"
      />
    </div>

    <!-- 复制弹窗 -->
    <Modal
      v-model="copyVisible"
      title="复制试卷"
      class-name="vertical-center-modal"
      @on-ok="DoCopy"
    >
      <div class="header">
        归属老师：
        <Select v-model="copyTeacherId" placeholder="请选择" style="width:280px;">
          <Option
            v-for="t in teacherList"
            :key="t.uid || t.id"
            :value="t.uid || t.id"
          >{{ t.name || t.nickname }}</Option>
        </Select>
      </div>
    </Modal>

    <!-- 下发弹窗 -->
    <Modal
      v-model="sendVisible"
      title="下发试卷"
      class-name="vertical-center-modal"
      :width="780"
      @on-ok="DoSend"
    >
      <div class="send-modal">
        <Input
          v-model="sendKeyword"
          clearable
          search
          enter-button="搜索"
          placeholder="搜索班级名称"
          style="width:100%;margin-bottom:10px;"
          @on-search="OnSendSearch"
        />
        <i-table
          border
          :columns="sendColumns"
          :data="sendGroups"
          :height="240"
        />
        <div class="send-pager">
          <Page
            :total="sendGroupsTotal"
            :page-size="sendPageSize"
            :current="sendCurrentPage"
            size="small"
            show-total
            @on-change="ChangeSendPage"
          />
        </div>
        <div class="selected-section">
          <div class="selected-title">
            已选班级 ({{ sendSelectedItems.length }})
          </div>
          <div v-if="!sendSelectedItems.length" class="empty">请在上方勾选班级</div>
          <div
            v-for="(item, idx) in sendSelectedItems"
            :key="item.group_id"
            class="selected-row"
          >
            <span class="name" :title="item.group_name">{{ item.group_name }}</span>
            <DatePicker
              v-model="item.startTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="开始时间"
              style="width:200px;"
            />
            <span class="sep">~</span>
            <DatePicker
              v-model="item.endTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="结束时间"
              style="width:200px;"
            />
            <i-button
              type="text"
              size="small"
              style="color:#ed4014;"
              @click="RemoveSelectedItem(idx)"
            >移除</i-button>
          </div>
        </div>
      </div>
    </Modal>

    <!-- 撤回弹窗 -->
    <Modal
      v-model="cancelVisible"
      title="撤回下发"
      class-name="vertical-center-modal"
      :width="640"
      :loading="cancelLoading"
      @on-ok="DoCancel"
    >
      <div class="cancel-modal">
        <p class="tip">选择需要撤回下发的班级：</p>
        <i-table
          border
          :columns="cancelColumns"
          :data="cancelGroups"
          :height="300"
          @on-selection-change="OnCancelSelectionChange"
        />
      </div>
    </Modal>

    <!-- 预览弹窗 -->
    <evaluation-preview
      v-model="previewVisible"
      :hope-evaluation-id="previewId"
    />
  </div>
</template>

<script>
import evaluationApi from '@/lib/api/evaluation'
import schoolApi from '@/lib/api/school'
import EvaluationPreview from './preview.vue'
import { DateFormat } from '@lib/common.js'

export default {
  name: 'EvaluationList',
  components: { EvaluationPreview },
  data() {
    return {
      keyword: '',
      teacherId: 0,
      start: 0,
      pageSize: 10,
      currentPage: 1,
      count: 0,
      list: [],
      teacherList: [],
      copyVisible: false,
      copyTeacherId: '',
      copySourceId: '',
      previewVisible: false,
      previewId: '',
      sendVisible: false,
      sendRow: null,
      sendKeyword: '',
      sendStart: 0,
      sendPageSize: 10,
      sendCurrentPage: 1,
      sendGroups: [],
      sendGroupsTotal: 0,
      sendSelectedItems: [],
      sendColumns: [
        {
          title: '选择',
          width: 60,
          align: 'center',
          render: (h, params) => {
            const row = params.row
            const checked = this.sendSelectedItems.some(i => i.group_id === row.id)
            return h('Checkbox', {
              props: { value: checked },
              on: { 'on-change': v => this.ToggleSendItem(row, v) }
            })
          }
        },
        { title: '班级名称', key: 'name' },
        { title: '当前人数', key: 'cur_num', width: 100, align: 'center' }
      ],
      cancelVisible: false,
      cancelLoading: true,
      cancelRow: null,
      cancelGroups: [],
      cancelSelected: [],
      cancelColumns: [
        { type: 'selection', width: 50, align: 'center' },
        { title: '班级名称', key: 'group_name' },
        {
          title: '时间区间',
          render: (h, params) => {
            const s = params.row.start_time
            const e = params.row.end_time
            const fmt = t => t ? DateFormat(t * 1000, 'yyyy-MM-dd hh:mm') : '-'
            return h('span', `${fmt(s)} ~ ${fmt(e)}`)
          }
        }
      ],
      columns: [
        { title: 'ID', key: 'id', width: 80 },
        { title: '试卷ID', key: 'hope_evaluation_id', width: 140 },
        { title: '试卷名称', key: 'evaluation_name' },
        { title: '创建老师', key: 'teacher_name' },
        {
          title: '测评报告',
          key: 'is_show_report',
          width: 90,
          align: 'center',
          render: (h, params) => {
            const v = params.row.is_show_report
            const text = Number(v) === 0 ? '不显示' : '显示'
            return h('span', text)
          }
        },
        {
          title: '创建时间',
          key: 'create_time',
          render: (h, params) => {
            const t = params.row.create_time
            return h('span', t ? DateFormat(t * 1000, 'yyyy-MM-dd hh:mm') : '-')
          }
        },
        {
          title: '更新时间',
          key: 'update_time',
          render: (h, params) => {
            const t = params.row.update_time
            return h('span', t ? DateFormat(t * 1000, 'yyyy-MM-dd hh:mm') : '-')
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 360,
          align: 'center',
          render: (h, params) => {
            const row = params.row
            const sent = Number(row.send_status) === 1
            const mkBtn = (text, type, handler, extraStyle, disabled) => h('i-button', {
              props: { type, size: 'small', disabled: !!disabled },
              style: Object.assign({ marginRight: '6px' }, extraStyle || {}),
              on: { click: handler }
            }, text)
            const children = [
              mkBtn('预览', 'default', () => this.OpenPreview(row)),
              mkBtn('编辑', 'primary', () => sent ? null : this.GoEdit(row), null, sent),
              mkBtn('复制', 'warning', () => this.OpenCopy(row))
            ]
            if (sent) {
              children.push(mkBtn('查看报告', 'info', () => this.GoReport(row)))
              // 只要有任一学生完成测评(finish_count>0)，禁止撤回，按钮置灰
              const hasFinished = Number(row.finish_count) > 0
              const cancelBtn = mkBtn(
                '撤回',
                'error',
                () => hasFinished ? null : this.OpenCancel(row),
                { marginRight: '0' },
                hasFinished
              )
              children.push(
                hasFinished
                  ? h('Tooltip', {
                    props: { content: '已有学生完成测评，不可撤回', placement: 'top' },
                    style: { marginRight: '0' }
                  }, [cancelBtn])
                  : cancelBtn
              )
            } else {
              children.push(mkBtn('下发', 'success', () => this.OpenSend(row), { marginRight: '0' }))
            }
            return h('div', children)
          }
        }
      ]
    }
  },
  created() {
    this.LoadTeachers()
    this.GetList()
  },
  methods: {
    LoadTeachers() {
      schoolApi.GetAdminList({
        keyword: '',
        start: 0,
        rows: 100,
        type: 1
      }).then(res => {
        if (res.status == 1) {
          this.teacherList = res.data.list || []
        }
      })
    },
    GetList() {
      evaluationApi.GetList({
        keyword: this.keyword,
        teacherId: this.teacherId || 0,
        start: this.start,
        rows: this.pageSize
      }).then(res => {
        if (res.status == 1) {
          this.list = res.data.list || []
          this.count = res.data.total || 0
        } else {
          this.$Message.error(res.msg || '获取列表失败')
        }
      })
    },
    OnSearch() {
      this.start = 0
      this.currentPage = 1
      this.GetList()
    },
    OnFilterChange() {
      this.start = 0
      this.currentPage = 1
      this.GetList()
    },
    ChangePage(index) {
      this.currentPage = index
      this.start = (index - 1) * this.pageSize
      this.GetList()
    },
    ChangePageSize(size) {
      this.pageSize = size
      this.start = 0
      this.currentPage = 1
      this.GetList()
    },
    GoCreate() {
      this.$router.push({ name: 'evaluationEdit' })
    },
    GoEdit(row) {
      this.$router.push({
        name: 'evaluationEdit',
        query: {
          hope_evaluation_id: row.hope_evaluation_id,
          teacher_id: row.teacher_uid
        }
      })
    },
    OpenPreview(row) {
      this.previewId = row.hope_evaluation_id
      this.previewVisible = true
    },
    OpenCopy(row) {
      this.copySourceId = row.hope_evaluation_id
      this.copyTeacherId = row.teacher_uid
      this.copyVisible = true
    },
    DoCopy() {
      if (!this.copyTeacherId) {
        this.$Message.error('请选择归属老师')
        return
      }
      evaluationApi.CopyEvaluation({
        hopeEvaluationId: this.copySourceId,
        teacherId: this.copyTeacherId
      }).then(res => {
        if (res.status == 1) {
          this.$Message.success('复制成功')
          this.GetList()
        } else {
          this.$Message.error(res.msg || '复制失败')
        }
      })
    },
    OpenSend(row) {
      this.sendRow = row
      this.sendKeyword = ''
      this.sendStart = 0
      this.sendCurrentPage = 1
      this.sendGroups = []
      this.sendGroupsTotal = 0
      this.sendSelectedItems = []
      this.sendVisible = true
      this.LoadSendGroups()
    },
    LoadSendGroups() {
      if (!this.sendRow) return
      evaluationApi.GroupListForSend({
        teacherId: this.sendRow.teacher_uid,
        keyword: this.sendKeyword,
        start: this.sendStart,
        rows: this.sendPageSize
      }).then(res => {
        if (res.status == 1) {
          this.sendGroups = res.data.list || []
          this.sendGroupsTotal = res.data.total || 0
        } else {
          this.$Message.error(res.msg || '获取班级列表失败')
        }
      })
    },
    OnSendSearch() {
      this.sendStart = 0
      this.sendCurrentPage = 1
      this.LoadSendGroups()
    },
    ChangeSendPage(index) {
      this.sendCurrentPage = index
      this.sendStart = (index - 1) * this.sendPageSize
      this.LoadSendGroups()
    },
    ToggleSendItem(row, checked) {
      const idx = this.sendSelectedItems.findIndex(i => i.group_id === row.id)
      if (checked && idx === -1) {
        this.sendSelectedItems.push({
          group_id: row.id,
          group_name: row.name,
          startTime: null,
          endTime: null
        })
      } else if (!checked && idx !== -1) {
        this.sendSelectedItems.splice(idx, 1)
      }
    },
    RemoveSelectedItem(idx) {
      this.sendSelectedItems.splice(idx, 1)
    },
    DoSend() {
      if (!this.sendSelectedItems.length) {
        this.$Message.error('请至少选择一个班级')
        return
      }
      const nowSec = Math.floor(Date.now() / 1000)
      const items = []
      for (const item of this.sendSelectedItems) {
        if (!item.startTime || !item.endTime) {
          this.$Message.error(`「${item.group_name}」请设置开始和结束时间`)
          return
        }
        const s = Math.floor(new Date(item.startTime).getTime() / 1000)
        const e = Math.floor(new Date(item.endTime).getTime() / 1000)
        if (e <= s) {
          this.$Message.error(`「${item.group_name}」结束时间必须晚于开始时间`)
          return
        }
        if (e <= nowSec) {
          this.$Message.error(`「${item.group_name}」结束时间必须晚于当前时间`)
          return
        }
        items.push({ group_id: item.group_id, start_time: s, end_time: e })
      }
      evaluationApi.SendToGroups({
        hopeEvaluationId: this.sendRow.hope_evaluation_id,
        items
      }).then(res => {
        if (res.status == 1) {
          this.$Message.success('下发成功')
          this.sendVisible = false
          this.GetList()
        } else {
          this.$Message.error(res.msg || '下发失败')
        }
      })
    },
    OpenCancel(row) {
      this.cancelRow = row
      this.cancelGroups = []
      this.cancelSelected = []
      this.cancelLoading = true
      this.cancelVisible = true
      evaluationApi.SendGroupListForReport({
        hopeEvaluationId: row.hope_evaluation_id
      }).then(res => {
        if (res.status == 1) {
          this.cancelGroups = res.data || []
        } else {
          this.$Message.error(res.msg || '获取下发记录失败')
        }
      })
    },
    OnCancelSelectionChange(selection) {
      this.cancelSelected = selection
    },
    DoCancel() {
      if (!this.cancelSelected.length) {
        this.$Message.error('请至少选择一个班级')
        this.ResetCancelLoading()
        return
      }
      const tasks = this.cancelSelected.map(item => evaluationApi.CancelSend({ sendId: item.send_id }))
      Promise.all(tasks).then(results => {
        const failed = results.filter(r => r.status != 1)
        if (failed.length === 0) {
          this.$Message.success('撤回成功')
          this.cancelVisible = false
          this.GetList()
        } else {
          this.$Message.error(failed[0].msg || '部分撤回失败')
          this.ResetCancelLoading()
        }
      }).catch(() => {
        this.$Message.error('撤回请求失败')
        this.ResetCancelLoading()
      })
    },
    ResetCancelLoading() {
      this.cancelLoading = false
      this.$nextTick(() => { this.cancelLoading = true })
    },
    GoReport(row) {
      this.$router.push({
        name: 'evaluationReport',
        query: {
          hope_evaluation_id: row.hope_evaluation_id,
          evaluation_name: row.evaluation_name
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  padding: 18px;
  box-sizing: border-box;
  background: #f3f3f3;
  .header {
    width: 100%;
    height: 48px;
    background: #fff;
    padding: 9px 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    .loginButton {
      width: 90px;
      height: 30px;
    }
    .filter {
      display: flex;
      align-items: center;
    }
  }
  .content {
    width: 100%;
    background: #fff;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .footer {
    height: 80px;
    width: 100%;
    background: #fff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: 24px 10px;
    box-sizing: border-box;
  }
}
</style>
<style lang="less">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .header {
    width: 100%;
    height: 36px;
    line-height: 36px;
    display: flex;
    margin-top: 12px;
  }
  .ivu-modal {
    top: 0;
  }
  .send-modal {
    .send-pager {
      display: flex;
      justify-content: flex-end;
      padding: 10px 0;
    }
    .selected-section {
      margin-top: 8px;
      border-top: 1px dashed #e8eaec;
      padding-top: 12px;
      max-height: 220px;
      overflow-y: auto;
      .selected-title {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 8px;
      }
      .empty {
        color: #999;
        font-size: 13px;
        padding: 8px 0;
      }
      .selected-row {
        display: flex;
        align-items: center;
        padding: 6px 0;
        gap: 8px;
        .name {
          flex: 0 0 140px;
          font-size: 13px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .sep {
          color: #999;
        }
      }
    }
  }
  .cancel-modal {
    .tip {
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
}
</style>
